import Button from '../../../components/base/Button';

export default function WhyLandingSection() {
  const benefits = [
    {
      icon: 'ri-arrow-right-up-line',
      title: '+30–60% di contatti',
      description:
        'Le Ads funzionano solo se la pagina finale è progettata per convertire e convince gli utenti a contattarti.',
    },
    {
      icon: 'ri-message-3-line',
      title: 'Coerenza Landing/Ads',
      description:
        'Se Ads e Landing non parlano la stessa lingua, l\'utente, "sfiduciato" abbandonerà la pagina senza convertire.',
    },
    {
      icon: 'ri-money-euro-box-line',
      title: 'I clic si pagano',
      description: `Ogni clic da Ads può costare anche 2€ o più. Se non si trasforma in un contatto, stai pagando visite inutili.`,
    },
    {
      icon: 'ri-filter-3-line',
      title: 'Macchina per Lead',
      description:
        'Una sola CTA, zero distrazioni. La landing lavora mentre le Ads portano traffico qualificato.',
    },
  ];

  const scrollToProcess = () => {
    const processSection = document.getElementById('processo');
    if (processSection) {
      processSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="why-landing" className="py-16 md:py-24 lg:py-32 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16 space-y-4 md:space-y-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#000000]">
            Quello che cambia davvero i risultati delle Ads
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            Trasforma le tue Ads in una macchina per lead con una landing page progettata per convertire.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white p-6 md:p-8 hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-[#000000] rounded-lg mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${benefit.icon} text-2xl md:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#000000] mb-2 md:mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm md:text-base text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}